import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import { useT } from '@/lib/i18n';

export interface LandingFaqItem {
  question: string;
  answer: string;
}

interface LandingPageFAQProps {
  heading?: string;
  intro?: string;
  faqs: LandingFaqItem[];
}

export function LandingPageFAQ({
  heading,
  intro,
  faqs,
}: LandingPageFAQProps) {
  const t = useT();
  const resolvedHeading = heading ?? t('Häufig gestellte Fragen', 'Frequently asked questions');
  return (
    <section className="py-20 md:py-28">
      <div className="container mx-auto px-4">
        <div className="mx-auto max-w-3xl">
          <div className="text-center">
            <h2 className="text-3xl font-bold tracking-tight text-foreground md:text-4xl">
              {resolvedHeading}
            </h2>
            {intro && (
              <p className="mt-4 text-lg text-muted-foreground">{intro}</p>
            )}
          </div>
          <Accordion type="single" collapsible className="mt-10">
            {faqs.map((faq, i) => (
              <AccordionItem key={i} value={`faq-${i}`}>
                <AccordionTrigger className="text-left text-base font-semibold">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="faq-answer text-base leading-relaxed text-muted-foreground">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}